const initialState = {
  isLongHaul: true,
  startDate: null,
  endDate: null,
  passengers: [],
  outboundFlightData: null,
  returnFlightData: null,
  outboundSeat: null,
  returnSeat: null
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  console.info(type, payload);
  switch (type) {
    case 'SET_LONGHAUL':
      return { ...state, isLongHaul: payload };

    case 'SET_STARTDATE':
      return { ...state, startDate: payload };

    case 'SET_ENDDATE':
      return { ...state, endDate: payload };

    case 'SET_OUTBOUND_FLIGHT_DATA':
      return { ...state, outboundFlightData: payload };

    case 'SET_RETURN_FLIGHT_DATA':
      return { ...state, returnFlightData: payload };

    case 'SET_OUTBOUND_SEAT':
      return { ...state, outboundSeat: payload };

    case 'SET_RETURN_SEAT':
      return { ...state, returnSeat: payload };

    case 'SET_PASSENGERS':
      return { ...state, passengers: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/reducers/mainReducer.js